import generateSitePreview from './generate-site-preview';

export default {
  generateSitePreview,
};
